export const fieldsTypes = {
  singleLineText: 'SINGLE_LINE_TEXT',
  number: 'NUMBER',
  multiLineText: 'MULTI_LINE_TEXT',
  group: 'GROUP',
  tags: 'TAGS',
  permanentUrl: 'PERMANENT_URL',
  // Select family — values match the field's display_type carried in the schema.
  select: 'SELECT',
  radio: 'RADIO',
  checkbox: 'CHECKBOX',
}

export const modeTypes = {
  edit: 'edit',
  readOnly: 'readOnly'
}